import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type { IProductDataV3 } from '@df/catalog/product/product';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import type { ProductDecorator } from '../../../../model/product/product.decorator';
import { ProductLayoutComponent } from '../product-layout.component';
import { RatingComponent } from '../../../../../ui/common/rating.component';

@Component({
    selector: 'product-layout-reviews',
    templateUrl: './product-layout-reviews.component.html',
    styleUrl: './product-layout-reviews.component.scss',
    host: {
        '[class.is-top]': 'top()'
    },
    imports: [RatingComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductLayoutReviewsComponent extends UiComponent {
    readonly product = input.required<ProductDecorator<IProductDataV3>>();
    readonly productViewLayout = input.required<ProductLayoutComponent>();
    readonly top = input<boolean>(false);

    readonly parent = computed(() => this.productViewLayout().parent);
    readonly count = computed(() => this.parent()?.data?.reviews?.count ?? 0);
    readonly rating = computed(() => this.parent()?.data?.reviews?.rating ?? 0);
}
